<template>
	<div class="col-xs-12 dynvibeStory">
		<div class="col-lg-2 col-xs-12 dynvibeStoryInfo">
			<a :href="post['post_url']" target="_blank" style="display: block">
				<i v-bind:class="'fab fa-' + post['post_media']"></i>
				<span class="dynvibeStoryInfoDate">{{ getDate(post.post_date, "date") }}</span>
				<span class="dynvibeStoryInfoHour">{{ getDate(post.post_date, "time") }}</span>
			</a>

			<highlight v-if="!middle" :idpost="post_id" :prop-active="getHighlight(post)" :ref="'highlight-' + post_id"></highlight>
		</div>
		<div v-if="post.post_picture" class="col-lg-3 col-xs-12 dynvibeStoryImg">
			<a
				:href="post.post_url"
				target="_blank"
				class="postPicture_small"
				v-bind:style="{
					backgroundImage:
						'url(' +
						post.post_picture +
						'),url(' +
						picture_host +
						post.profile_id +
						'/source/' +
						post.post_url.split('/')[4] +
						'.jpg' +
						')',
				}"
			>
			</a>
		</div>
		<div v-else class="col-lg-3 col-xs-12 dynvibeStoryImg">
			<div class="emptyPicture"></div>
		</div>

		<div class="col-lg-7 col-xs-12 dynvibeStoryContenu">
			<p>
				<span class="dynvibeToTranslateResult" v-html="postTitle"></span>
				<span class="dynvibeToTranslateResult" v-html="postDescription"></span>
				<button class="dynvibeTranslate dynvibeButton" @click="translatePost()">Translate</button>
				<span v-if="loadingTranslate" class="dynvibeLoading" style="min-height: 0px"></span>
				<span v-if="translateResult" class="translateResult">
					{{ translateResult }}
				</span>
			</p>
			<div v-if="post.mastertags">
				<div v-for="mastertag in post.mastertags" v-bind:key="mastertag.mastertag" class="dynvibePostMastertag dynvibeNeutral">
					<span>{{ mastertag.label }}</span>
				</div>
			</div>
		</div>
		<div v-if="middle" class="col-lg-12 col-xs-12 pull-right dynvibeStoryInfo">
			<div class="dynvibeStoryStats">
				<span title="likes" alt="likes"><span class="far fa-thumbs-up"></span> {{ post.post_likes }}</span>
				<span v-if="post.post_media === 'instagram'" title="comments" alt="comments"
					><span class="far fa-comment"></span> {{ post.post_comments }}
				</span>
				<span v-if="post.post_media === 'twitter'" title="shares" alt="shares"
					><span class="fas fa-retweet"></span>{{ post.post_shares || "0" }}
				</span>

				<span
					class="dynvibeStoryScore"
					title="Dynvibe Impact score is: ?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (? followers) Content: ? shares, ? favorites"
					alt="Dynvibe Impact score is: ?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (? followers) Content: ? shares, ? favorites"
				>
					{{ post.post_impact_score || "0" }}
				</span>
			</div>
		</div>
	</div>
</template>
<script>
import storyMixin from "@/mixins/storyMixin.js";

export default {
	mixins: [storyMixin],
	inject: ["picture_host"],
	props: {
		middle: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style scoped>
.translateResult {
	display: block;
	margin-bottom: 10px;
}

.translateResult {
	padding: 10px;
	border: 1px dashed #33d1cd;
	min-height: 60px;
}

.highlightInclude {
	white-space: pre-wrap;
}

.postPicture_big {
	width: 200px;
	height: 200px;
	max-width: 100%;
	display: block;
	background-position: center;
	background-size: cover;
}

.postPicture_small {
	width: 130px;
	height: 130px;
	margin-right: 15px;
	display: block;
	background-position: center;
	background-size: cover;
}

.dynvibeStoryStats {
	display: flex;
	align-items: center;
	height: 35px;
	float: right;
	font-size: 18px;
	color: #9d9d9d;
}
.dynvibeStoryStats > span {
	margin-left: 15px;
}

.dynvibeStoryStats > span > span {
	margin-right: 3px;
}

.dynvibeStoryScore {
	font-size: 26px;
	min-width: 100px;
	text-align: right;
}
</style>
